<template>
    <div class="training-ranking">
        <div class="training-ranking_title">
            <span>技能考核</span>
        </div>

        <div class="training-ranking_filter">
            <div>
                <el-cascader
                    style="width: 250px; margin-right: 10px"
                    v-model="courseValue"
                    :options="courseOptions"
                    :props="cascProp"
                    @change="handleChapterChange"
                    :show-all-levels="false"
                ></el-cascader>

                <el-select v-model="project_id" placeholder="请选择" style="width: 250px; " @change="handleProjectChange">
                    <el-option v-for="item in project_list" :key="item.project_id" :label="item.project_title" :value="item.project_id">
                    </el-option>
                </el-select>
            </div>

            <el-button type="primary" @click="handleBack">返回</el-button>
        </div>

        <div class="training-ranking_box">
            <div class="box-top">
                <template v-if="TrainingData.list.length > 0">
                    <div class="top-title">技能考核分数排名</div>
                    <div class="top-chart" ref="trainingChartRef"></div>
                </template>

                <div class="box-empty" v-else>
                    <img src="@/assets/images/discussion-empty.png" alt="" />
                    <span>暂无数据</span>
                </div>
            </div>

            <div class="box-bottom">
                <div class="score-item" v-for="scoreItem in scoreOptions" :key="scoreItem.key">
                    <div class="score-item_top">
                        <div class="top-label">{{ scoreItem.label }}</div>
                    </div>

                    <div class="score-item_bottom">
                        <el-progress
                            type="circle"
                            :percentage="TrainingData[scoreItem.key]"
                            :width="160"
                            :stroke-width="12"
                            stroke-linecap="butt"
                            :color="scoreItem.color"
                            :show-text="false"
                        ></el-progress>

                        <div class="progress-text">{{ TrainingData[scoreItem.key] }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <SkillAssessmentDetailDialog
            :student-id="dialogData.s_id"
            :project-id="project_id"
            :visible="dialogData.visible"
            :is-operate="false"
            :zhang="dialogData.zhangIndex"
            :jie="dialogData.jieIndex"
            @close="closeDialog"
            @preview="previewSource"
        ></SkillAssessmentDetailDialog> -->

        <div class="preview-box" v-if="previewUrl && !loading">
            <ElImageViewer class="preview-img" :url-list="[previewUrl]" alt="" v-if="['jpg', 'png'].includes(getFileExtensiion)" />

            <i class="el-icon-close" @click="closePreview"></i>
        </div>
    </div>
</template>

<script>
// import SkillAssessmentDetailDialog from "../../qualityCourse/SkillAssessmentDetailDialog.vue";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
    name: "TrainRanking",
    data() {
        return {
            scoreOptions: [
                { key: "max_score", label: "最高分", color: "#165DFF" },
                { key: "avg_score", label: "平均分", color: "#4FD1C5" },
                { key: "min_score", label: "最低分", color: "#FEAE65" },
            ],
            TrainingData: {
                list: [],
                max_score: 0,
                avg_score: 0,
                min_score: 0,
            },
            project_list: [],
            project_id: undefined,
            chartMap: new Map(),
            dialogData: {
                s_id: undefined,
                visible: false,
                zhangIndex: undefined,
                jieIndex: undefined,
            },
            previewUrl: "", // 预览文件名路径
            courseOptions: [],
            courseValue: [],
            cascProp: { label: "name", children: "children", value: "index" },
            course_id: undefined,
        };
    },
    components: {
        // SkillAssessmentDetailDialog,
        ElImageViewer,
    },
    mounted() {
        // this.getProjectList();
        // this.getTrainingData();
        this.getCourseList();

        window.addEventListener("resize", this.resizeChart);
    },
    computed: {
        // 获得文件扩展名
        getFileExtensiion() {
            const fileExtension = this.previewUrl?.slice(((this.previewUrl.lastIndexOf(".") - 1) >>> 0) + 2).toLowerCase();
            return fileExtension;
        },
    },
    methods: {
        // 获取课程列表
        getCourseList() {
            this.course_id = Number(this.$route.query.course_id);
            // /admin/cefinoorsu;
            const params = {
                id: Number(this.$route.query.course_id),
            };

            this.$shttp.axiosGetBy(this.$api.courseContent, params, (res) => {
                if (res.code === 200) {
                    const courseContent = res.data.course_content;
                    this.formatterCourseList(courseContent);

                    this.courseOptions = courseContent;
                    this.courseValue = [0, 0];

                    this.getProjectList();
                }
            });
        },

        formatterCourseList(courseList) {
            for (let i = 0; i < courseList.length; i++) {
                const courseItem = courseList[i];

                if (!!courseItem.id) return false;

                courseItem.index = i;

                if (courseItem.children && courseItem.children.length > 0) {
                    if (!this.formatterCourseList(courseItem.children)) {
                        delete courseItem.children;
                    }
                }
            }

            return true;
        },

        getProjectList() {
            if (this.courseValue.length < 2) return;

            const params = {
                c_id: Number(this.$route.query.class_id),
                course_id: Number(this.$route.query.course_id),
                course_chapter: this.courseValue[0],
                course_node: this.courseValue[1],
            };

            this.$shttp.axiosGetBy(this.$api.evaluation_training_project, params, (res) => {
                if (res.code === 200) {
                    this.project_list = res.data.list || [];

                    if (this.project_list.length > 0) {
                        this.project_id = this.project_list[0].project_id;

                        this.getTrainingData();
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        handleChapterChange(val) {
            this.courseValue = val;
            this.getProjectList();
        },

        getTrainingData() {
            const params = {
                c_id: Number(this.$route.query.class_id),
                course_id: Number(this.$route.query.course_id),
                course_chapter: this.courseValue[0],
                course_node: this.courseValue[1],
                project_id: this.project_id,
            };

            this.$shttp.axiosGetBy(this.$api.evaluation_training_list, params, (res) => {
                if (res.code === 200) {
                    this.TrainingData = res.data;
                    this.TrainingData.list = this.TrainingData.list.sort((a, b) => {
                        return b.score - a.score;
                    });

                    this.$nextTick(() => {
                        this.setTrainingChart();
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        handleProjectChange(project_id) {
            this.project_id = project_id;
            this.getTrainingData();
        },

        resizeChart() {
            for (const [_, value] of this.chartMap) {
                value.resize();
            }
        },

        setTrainingChart() {
            if (!this.$refs.trainingChartRef) return;
            const chart = this.$echarts.init(this.$refs.trainingChartRef);
            const xData = this.TrainingData.list.map((item) => {
                const data = { s_id: item.s_id, s_name: item.s_name };
                return JSON.stringify(data);
            });
            const yData = this.TrainingData.list.map((item) => item.score);

            const options = {
                grid: {
                    left: "3%",
                    right: "1%",
                    bottom: "30%",
                    top: "5%",
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        shadowStyle: {
                            opacity: 0,
                        },
                    },
                    borderWidth: 0,
                    backgroundColor: "#ffffff",
                    extraCssText:
                        "box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.08), 0px 16px 24px 2px rgba(0,0,0,0.04), 0px 6px 30px 5px rgba(0,0,0,0.05);",
                    formatter: function(params) {
                        const _params = params[0];
                        const xData = JSON.parse(_params.name);
                        const yData = _params.data;

                        return `
                            <div class="bar-tooltip">
                                <div class="tooltip-item">
                                    <div class="tooltip-item_title">${xData.s_name}</div>
                                    <div class="tooltip-item_score">
                                        <span>分数：</span>
                                        <span>${yData}</span>
                                    </div>
                                </div>
                            </div>
                        `;
                    },
                },
                xAxis: {
                    type: "category",
                    data: xData,
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                        },
                    },
                    axisLabel: {
                        formatter: function(params) {
                            const data = JSON.parse(params);
                            return data.s_name;
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    max: 100,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        lineStyle: {
                            type: "dashed",
                        },
                    },
                },
                series: [
                    {
                        data: yData,
                        type: "bar",
                        barMaxWidth: 24,
                        itemStyle: {
                            color: "#165DFF",
                        },
                    },
                ],
            };

            chart.setOption(options);

            const _this = this;
            chart.getZr().on("click", (params) => {
                let containPixel = [params.offsetX, params.offsetY];
                if (chart.containPixel("grid", containPixel)) {
                    const xIndex = chart.convertFromPixel({ seriesIndex: 0 }, containPixel)[0]; // 获取是第几个数据
                    const opData = chart.getOption();

                    const data = JSON.parse(opData.xAxis[0].data[xIndex]);
                        console.log(data, this.$route.query);
                    this.$router.push({
                        path: "/qualityCourse/teacher/dataEvaluationIndex/trainingDetail",
                        query: { 
                            s_id: data.s_id, 
                            class_id: this.$route.query.class_id,
                            course_id: Number(this.$route.query.course_id),
                            project_id: this.project_id,
                            zhangIndex: this.courseValue[0],
                            jieIndex: this.courseValue[1],
                        },
                    });
                    // this.dialogData.s_id = data.s_id;
                    // this.dialogData.visible = true;
                    // this.dialogData.zhangIndex = _this.courseValue[0];
                    // this.dialogData.jieIndex = _this.courseValue[1];
                }
            });

            if (!this.chartMap.has("trainingChart")) {
                this.chartMap.set("trainingChart", chart);
            }
        },

        // 关闭弹框
        closeDialog() {
            // this.dialogData.s_id = undefined;
            // this.dialogData.visible = false;
        },

        // 预览文件
        previewSource(url) {
            this.previewUrl = url;
        },

        // 关闭文件预览
        closePreview() {
            this.previewUrl = "";
        },

        handleBack() {
            this.course_id = undefined;
            this.$router.back();
        },
    },

    activated() {
        if (!this.course_id || Number(this.$route.query.course_id) !== this.course_id) {
            this.getCourseList();
        }
    },

    destroyed() {
        window.removeEventListener("resize", this.resizeChart);
    },
};
</script>

<style lang="scss" scoped>
::v-deep .bar-tooltip {
    padding: 14px;
    color: #333333;

    .tooltip-item {
        &:not(.tooltip-item:last-of-type) {
            margin-bottom: 10px;
        }

        &_title {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
        }

        &_score {
            min-width: 100px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // gap: 70px;
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
        }
    }
}

.training-ranking {
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    background-color: #efefef;

    &_title {
        font-family: PingFang-SC, PingFang-SC;
        height: 24px;
        font-weight: 800;
        font-size: 24px;
        color: #333333;
        line-height: 24px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &_filter {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        .el-button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 88px;
            height: 36px;
        }

        ::v-deep .el-input__inner {
            background-color: #ffffff !important;
        }
    }

    &_box {
        height: calc(100% - 100px);
        // background-color: #333333;

        .box-top {
            height: calc(100% - 306px);
            background-color: #ffffff;
            border-radius: 8px;
            box-sizing: border-box;
            padding: 24px;

            .top-title {
                height: 24px;
                font-family: PingFang-SC, PingFang-SC;
                font-weight: 500;
                font-size: 16px;
                color: #26292e;
                line-height: 24px;
                margin-bottom: 50px;
            }

            .top-chart {
                height: calc(100% - 74px);
                // background-color: lightgray;
            }

            .box-empty {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                gap: 20px;

                span {
                    height: 20px;
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    line-height: 16px;
                }
            }
        }

        .box-bottom {
            height: 286px;
            margin-top: 20px;
            display: flex;
            gap: 16px;

            .score-item {
                width: calc((100% - 32px) / 3);
                height: 100%;
                background-color: #ffffff;
                border-radius: 8px;
                box-sizing: border-box;
                padding: 24px;
                overflow: hidden;

                &_top {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .top-label {
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 500;
                        font-size: 16px;
                        color: #000000;
                        flex-shrink: 0;
                    }

                    .top-enter {
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        cursor: pointer;

                        img {
                            width: 16px;
                            height: 16px;
                            object-fit: cover;
                        }

                        span {
                            font-family: PingFang-SC, PingFang-SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #006eff;
                            flex-shrink: 0;
                        }
                    }
                }

                &_bottom {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 40px;
                    position: relative;

                    .progress-text {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 600;
                        font-size: 36px;
                        color: #000000;
                    }
                }
            }
        }
    }

    .preview-box {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        margin: 0;
        z-index: 9999;
        background-color: rgba(0, 0, 0, 0.3);

        ::v-deep .el-image-viewer__wrapper {
            .el-image-viewer__mask {
                display: none;
            }

            .el-icon-circle-close {
                display: none;
            }

            .el-image-viewer__canvas img {
                width: 40% !important;
                height: auto !important;
            }
        }

        .el-icon-close {
            position: absolute;
            right: 50px;
            top: 30px;
            font-size: 40px;
            cursor: pointer;
            color: #ffffffda;
            z-index: 9999;
        }
    }

    ::v-deep .el-dialog {
        position: absolute;
        margin: 0 !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-height: 90vh;
        overflow: hidden;

        .el-dialog__header {
            padding: 15px 20px;
        }

        .el-dialog__body {
            padding: 0;
        }
    }
}
</style>
